import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type AdminMilestoneView = 'component' | 'subawardee';

interface AdminMilestoneViewStore {
  view: AdminMilestoneView;
  setView: (view: AdminMilestoneView) => void;
}

export const useAdminMilestoneViewStore = create<AdminMilestoneViewStore>()(
  persist(
    (set) => ({
      view: 'subawardee',
      setView: (view) => set({ view }),
    }),
    { name: 'admin-milestone-view' }
  )
);
